(function (root) {
	function initializeStripe(key, confirmUrl) {
		var stripe = Stripe(key);

		function registerElements(elements) {
			var stripeCard = document.querySelector('.stripe-card');
			var form = stripeCard.querySelector('form');
			var error = form.querySelector('.error');
			var errorMessage = error.querySelector('.message');

			function setErrorMessage(message) {
				errorMessage.innerText = message;
				if (message) {
					error.classList.add('visible');
				} else {
					error.classList.remove('visible');
				}
			}


			function handleServerResponse(response) {
				if (response.error) {
					setErrorMessage(response.error);
					stripeCard.classList.remove('submitting');
				} else if (response.requires_action) {
					// Use Stripe.js to handle required card action
					setErrorMessage('');

					stripe.handleCardAction(
						response.payment_intent_client_secret
					).then(function(result) {
						if (result.error) {
							setErrorMessage(result.error.message);
							stripeCard.classList.remove('submitting');
						} else {
							// The card action has been handled
							// The PaymentIntent can be confirmed again on the server
							setErrorMessage('');
							$.ajax({
								url: confirmUrl,
								type: 'POST',
								data: JSON.stringify({ payment_intent_id: result.paymentIntent.id }),
								contentType: 'application/json',
								dataType: 'json',
								success: function(data){
									handleServerResponse(data);
								}
							});
						}
					});
				} else {
					stripeCard.classList.remove('submitting');
					stripeCard.classList.add('submitted');

					if (response.success) {
						window.location = response.redirect;
					}
				}
			}

			function triggerBrowserValidation() {
				// The only way to trigger HTML5 form validation UI is to fake a user submit
				// event.
				var submit = document.createElement('input');
				submit.type = 'submit';
				submit.style.display = 'none';
				form.appendChild(submit);
				submit.click();
				submit.remove();
			}

			// Listen for errors from each Element, and show error messages in the UI.
			var savedErrors = {};
			elements.forEach(function(element, idx) {
				element.on('change', function(event) {
					if (event.error) {
						savedErrors[idx] = event.error.message;
						setErrorMessage(event.error.message);
						stripeCard.classList.remove('submitting');
					} else {
						savedErrors[idx] = null;

						// Loop over the saved errors and find the first one, if any.
						var nextError = Object.keys(savedErrors)
							.sort()
							.reduce(function(maybeFoundError, key) {
								return maybeFoundError || savedErrors[key];
							}, null);

						if (nextError) {
							// Now that they've fixed the current error, show another one.
							setErrorMessage(nextError);
							stripeCard.classList.remove('submitting');
						}
					}
				});
			});

			// Listen on the form's 'submit' handler...
			form.addEventListener('submit', function(e) {
				e.preventDefault();

				// Trigger HTML5 validation UI on the form if any of the inputs fail
				// validation.
				var plainInputsValid = true;
				Array.prototype.forEach.call(form.querySelectorAll('input'), function(
					input
				) {
					if (input.checkValidity && !input.checkValidity()) {
						plainInputsValid = false;
						return;
					}
				});
				if (!plainInputsValid) {
					triggerBrowserValidation();
					return;
				}

				// Show a loading screen...
				stripeCard.classList.add('submitting');

				// Start payment
				stripe.createPaymentMethod('card', elements[0], {}).then(function(result) {
					if (result.error) {
						setErrorMessage(result.error.message);
						stripeCard.classList.remove('submitting');
					} else {
						setErrorMessage('');
						// Otherwise send paymentMethod.id to your server (see Step 2)
						$.ajax({
							url: confirmUrl,
							type: 'POST',
							data: JSON.stringify({ payment_method_id: result.paymentMethod.id }),
							contentType: 'application/json',
							dataType: 'json',
							success: function(data){
								// Handle server response (see Step 3)
								handleServerResponse(data);
							}
						});
					}
				});
			});
		}

		var style = {
			base: {
				color: '#32325d',
				fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
				fontSmoothing: 'antialiased',
				fontSize: '16px',
				'::placeholder': {
					color: '#aab7c4'
				}
			},
			invalid: {
				color: '#fa755a',
				iconColor: '#fa755a'
			}
		};

		var elementStyles = {
			base: {
				color: '#32325D',
				fontWeight: 500,
				fontFamily: 'Source Code Pro, Consolas, Menlo, monospace',
				fontSize: '16px',
				fontSmoothing: 'antialiased',

				'::placeholder': {
					color: '#CFD7DF',
				},
				':-webkit-autofill': {
					color: '#e39f48',
				},
			},
			invalid: {
				color: '#E25950',

				'::placeholder': {
					color: '#FFCCA5',
				},
			},
		};
		var elements = stripe.elements();
		var inputs = document.querySelectorAll('.cell.stripe-container .input');

		Array.prototype.forEach.call(inputs, function(input) {
			input.addEventListener('focus', function() {
				input.classList.add('focused');
			});
			input.addEventListener('blur', function() {
				input.classList.remove('focused');
			});
			input.addEventListener('keyup', function() {
				if (input.value.length === 0) {
					input.classList.add('empty');
				} else {
					input.classList.remove('empty');
				}
			});
		});

		var elementClasses = {
			focus: 'focused',
			empty: 'empty',
			invalid: 'invalid',
		};

		var cardNumber = elements.create('cardNumber', {
			style: elementStyles,
			classes: elementClasses,
		});
		cardNumber.mount('#card-number');

		var cardExpiry = elements.create('cardExpiry', {
			style: elementStyles,
			classes: elementClasses,
		});
		cardExpiry.mount('#card-expiry');

		var cardCvc = elements.create('cardCvc', {
			style: elementStyles,
			classes: elementClasses,
		});
		cardCvc.mount('#card-cvc');

		registerElements([cardNumber, cardExpiry, cardCvc], 'stripe-card');
	};

	if (typeof exports === 'object') {
		// CommonJS
		module.exports = initializeStripe;
	} else if (typeof define === 'function' && define.amd) {
		// AMD. Register as an anonymous module.
		define([], function () { return initializeStripe; })
	} else {
		// Browser globals
		root.initializeStripe = initializeStripe;
	}
}(this));
